import { useCallback } from 'react';

/**
 * Hook personalizado para manipular a construção de URLs de imagens com base no ambiente
 * @returns {Object} Um objeto contendo a função buildImageUrl
 */
export function useImageUrl() {
  /**
   * Constrói uma URL completa de imagem combinando a URL base com o caminho da imagem
   * @param {string} imagePath - O caminho relativo para o recurso da imagem
   * @returns {string} A URL completa para a imagem
   * @example
   * const { buildImageUrl } = useImageUrl();
   * const imageUrl = buildImageUrl('/images/avatar.jpg'); // retorna a baseURL com o path fornecido na chamada da função
   * const baseURL = buildImageUrl('') // retorna somente a baseURL
   */
  const buildImageUrl = useCallback((imagePath = '') => {
    const baseUrl =
      window.location.hostname === 'localhost'
        ? process.env.REACT_APP_PROXY_URL
        : window.location.origin;

    return `${baseUrl}${imagePath}`;
  }, []);

  return {
    buildImageUrl
  };
}
